var TechnicianTypes;
(function (TechnicianTypes) {
    TechnicianTypes["ScheduleOnly"] = "schedule_only";
})(TechnicianTypes || (TechnicianTypes = {}));
export default TechnicianTypes;
